// src/v2/leases/LeaseDocumentsTab.jsx
//
// LEASE-DETAIL-V5-S1: Documents tab shell.
//
// Renders the already-fetched `documents` array as a read-only register:
// filename (with storageUrl link), type chip, source badge, added-date.
// Wraps `ActivitySection` so the existing testid (activity-section-documents)
// and count badge are preserved for downstream tests.
//
// The "+ Upload" button is a visual affordance only — no write path is wired.
// Phase 2 will add the actual upload flow.

import React from "react";
import { T } from "../../app/tokens.js";
import { ActivitySection } from "../../features/leases/components/ActivitySection.jsx";
import { DocumentRow } from "../../features/leases/components/DocumentRow.jsx";

export function LeaseDocumentsTab({ documents = [] }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {/* Header row with + Upload affordance */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
        {/* Phase 2: wire upload flow here */}
        <button
          type="button"
          data-testid="documents-upload-button"
          disabled
          title="Upload (coming in Phase 2)"
          style={{
            fontSize:     T.fsXs,
            fontWeight:   T.fwSemibold,
            padding:      "5px 12px",
            borderRadius:  6,
            border:       `1px solid ${T.border}`,
            background:    T.lightGray,
            color:         T.mid,
            cursor:        "not-allowed",
            opacity:       0.6,
          }}
        >
          + Upload
        </button>
      </div>

      <ActivitySection
        title="Documents"
        count={documents.length}
        emptyText="No documents uploaded."
      >
        {documents.map((doc) => (
          <DocumentRow key={doc.id} doc={doc} />
        ))}
      </ActivitySection>
    </div>
  );
}
